import {get} from './base.service'
import {post} from './base.service'
export default{
    /* 获取区域列表 */
    loadArea(){
        return get('/app/hospital/area');
    },
    /* 获取科室列表 */
    loadDepart(params){
        return get('/app/register/dept/{areaId}',{params:params});
    },
    /* 获取机构下所有医生列表 */
    loadDoctor(params){
        // instuteCode 机构Id,暂时为102
        return get('/app/hospital/getAllDeptDoct/{instuteCode}',{params:params});
    },
    /* 获取医院下所有医生列表 */
    loadDoctorInHos(){
        return get('/app/hospital/docts');
    },
    /* 获取医生信息 */
    loadDoctorInfo(params){
        return get('/app/hospital/doct/{doctId}',{params:params});
    },
    /* 获取医生排班 */
    loadDoctorSchedule(params){
        return get('/app/register/doct/{areaId}/{deptId}/{regDate}',{params:params});
    },
    /* 获取日期列表 */
    loadTimeTable(params){
        return get('/app/register/date/{areaId}/{deptId}',{params:params});
    },
    /* 获取实时排班 */
    loadTimeSchedules(params){
        return get('/app/register/scheduling/{areaId}/{deptId}/{regDate}/{doctId}/{rankId}',{params:params});
    },
    /* 挂号锁号 */
    registLock(params){
        return post('/app/register/lock',params);
    },
    /*停诊提醒*/
    loadStopAdmission() {
        return get('/app/register/stoppingAdmission');
    }
}



// WEBPACK FOOTER //
// ./src/service/register.service.js